<template>
  <header class="gs-promo-header">
    <div class="gs-promo-header__intro">
      <p class="gs-promo-header__eyebrow">{{ whitelabelAppData('sell').title }} · Affiliates</p>
      <h1>Affiliate portals &amp; tools</h1>
      <p class="gs-promo-header__subtitle">
        Create the portal your affiliates log into, fill it with swipes, banners and links, then share or embed it.
      </p>
    </div>

    <div class="gs-promo-header__controls">
      <gs-field label="Funnel" class="gs-promo-header__field">
        <gs-name-select
          v-if="funnels && funnels && funnels.length"
          v-model="localSelectedFunnelId"
          size="full"
          max-height="min(560px, calc(100vh - 180px))"
          :options="funnelsOptions"
          :placeholder="$t('frontend_resources_index_funnels')"
          @change="changedPromoResources"
        />
      </gs-field>

      <gs-button
        v-if="funnel"
        variant="primary"
        class="gs-promo-header__button"
        @click="$emit('openCreateResourceModal')"
      >
        <gs-icon name="plus" size="18" />
        {{ $t('frontend_resources_index_create_new_funnel') }}
      </gs-button>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    funnels: {
      type: Array,
      default: () => [],
    },
    funnel: {
      type: Object,
      default: () => {},
    },
    selectedFunnelId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localSelectedFunnelId: this.selectedFunnelId,
    };
  },
  computed: {
    funnelsOptions() {
      return this.funnels.map((funnel) => {
        return {
          value: funnel.id,
          text: funnel.internal_name,
        };
      });
    },
  },
  methods: {
    changedPromoResources() {
      this.$emit('updateSelectedFunnelId', this.localSelectedFunnelId);

      this.$router.push({
        name: 'funnel_resources',
        params: {
          id: this.localSelectedFunnelId,
        },
      });
    },
  },
}
</script>
<style scoped>
.gs-promo-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, auto);
  gap: 20px 32px;
  align-items: end;
  padding: 20px 24px;
  color: var(--gs-foreground);
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-promo-header__intro {
  min-width: 0;
}

.gs-promo-header__eyebrow {
  margin: 0 0 4px;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gs-promo-header__intro h1 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
}

.gs-promo-header__subtitle {
  margin: 0;
  max-width: 62ch;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.5;
}

.gs-promo-header__controls {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  justify-content: flex-end;
  flex-wrap: wrap;
  min-width: 0;
}

.gs-promo-header__field {
  flex: 1 1 360px;
  min-width: 0;
  max-width: 420px;
}

.gs-promo-header__button {
  flex: none;
  gap: 8px;
}

@media (max-width: 1023px) {
  .gs-promo-header {
    grid-template-columns: minmax(0, 1fr);
    align-items: stretch;
  }

  .gs-promo-header__controls {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .gs-promo-header__field {
    max-width: none;
  }
}
</style>
